package ca.northroot.app.ui.theme

import androidx.compose.ui.graphics.Color

val Purple80 = Color(0xFFD0BCFF)
val PurpleGrey80 = Color(0xFFCCC2DC)
val Pink80 = Color(0xFFEFB8C8)

val Purple40 = Color(0xFF6650a4)
val PurpleGrey40 = Color(0xFF625b71)
val Pink40 = Color(0xFF7D5260)

// Northroot Brand Colors
val NorthrootForestGreen = Color(0xFF1B4332)
val NorthrootDeepForest = Color(0xFF0B1A14)
val NorthrootSageGreen = Color(0xFF74C69D)
val NorthrootGold = Color(0xFFD4AF37)
val NorthrootBackground = Color(0xFFF8F9FA)
val NorthrootWhite = Color(0xFFFFFFFF)
val NorthrootBlack = Color(0xFF000000)
val NorthrootGray = Color(0xFF6C757D)
val NorthrootLightGray = Color(0xFFDEE2E6)
val NorthrootRed = Color(0xFFBC4749)
